import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Import your components
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Programs from './pages/Programs';
import Review from './pages/Review'; // Add this import
import Contact from './pages/Contact';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton'; // Add this import
// In your App.js or layout component
import myIcon from './assets/my-icon.png';

// Then in your component
<img src={myIcon} alt="Icon" />

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/review" element={<Review />} /> {/* Add this route */}
            <Route path="/contact" element={<Contact />} />
            
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton /> {/* Add WhatsApp button here */}
      </div>
    </Router>
  );
}

export default App;